<lib-full-screen>
  <lib-main-menu [fullWidth]="true" class="z2" color="default">
    <div class="regular" left>
      <div class="font-large">{{'DOCUMENT.SIGN_FIELD_SETTINGS' | translate}}</div>
      <div class="font-medium">{{'DOCUMENT_EDITOR.DRAW_SIGN_FIELD_HINT' | translate}}</div>
    </div>

    <div class="flex" right>
      <div class="mr2">
        <lib-button weight="secondary" class="btn-medium" (click)="onCloseEditor()">
          {{'COMMON.CANCEL' | translate}}
        </lib-button>
      </div>

      <lib-button weight="primary" class="btn-medium" (click)="onSaveSignFields()">
        {{'COMMON.SAVE' | translate}}
      </lib-button>
    </div>
  </lib-main-menu>

  <mat-drawer-container class="app-doc-editor-container" autosize>
    <mat-drawer #drawer mode="side" opened>
      <app-doc-editor-side-panel
        [signers]="signers"
        [activeSigner]="activeSigner"
        [showSignFieldPriority]="showSignFieldPriority"
        [signFields]="signFields"
        [activeSignField]="activeSignField"
        (clickSigner)="onSignerClick($event)"
        (clickSignField)="onSignFieldItemClicked($event)"
        (deleteSignField)="onDeleteSignField($event)"
        (changeSignFieldType)="onChangeSignFieldType($event)"
        (changeSignFieldPriority)="onChangeSignFieldPriority($event)"
      ></app-doc-editor-side-panel>
    </mat-drawer>

    <lib-document-viewer
      class="app-document-viewer block"
      [pdfOptions]="{url: this.documentData.content}"
    >
      <ng-template #pageOverlayTmp let-index="index">
        <app-sign-field-canvas
          class="absolute top-0 left-0 z0"
          [class.z1]="isDrawing"
          [minAllowedSignFieldSize]="profileService.getCurrentProfile().minSignFieldSize"
          (drawingStarted)="onDrawingStarted()"
          (drawingFinished)="onDrawingFinished($event, index)"
        ></app-sign-field-canvas>

        <app-sign-field-viewer
          class="overflow-hidden"
          [signers]="signers"
          [activeSigner]="activeSigner"
          [signFields]="signFields | filterSignFieldsOnPage: index"
          [activeSignField]="activeSignField"
          (clickSignField)="onSignFieldItemClicked($event)"
          (changeSignFieldType)="onChangeSignFieldType($event)"
          (finishSignFieldEdit)="onFinishSignFieldEdit($event)"
          (deleteSignField)="onDeleteSignField($event)"
        ></app-sign-field-viewer>
      </ng-template>
    </lib-document-viewer>
  </mat-drawer-container>
</lib-full-screen>
